import { SkinDateFormat, SkinInterval } from "./skin-date"

export enum EsCriteriaOperator {
    EXISTS = "exists",
    IS_MISSING = "is-missing",
    IS_MISSING_TO_LANG = "is-missing-to-lang",
    EQUALS = "equals",
    NOT_EQUALS = "not-equals",
    IS_TRUE = "true",
    IS_FALSE = "false",
    IS_INCLUDED = "is-included",
    IS_EXCLUDED = "is-excluded",
    LESS_THAN = "less",
    LESS_INCLUDED = "less-or-equal",
    GREATER_THAN = "greater",
    GREATER_INCLUDED = "greater-or-equal",
    CONTAINS = "contains",
    NOT_CONTAINS = "not-contains",
    START_WITH = "start-with",
    END_WITH = "end-with",
    CROSSED_SEARCH = "crossed-search",
    SEARCH_ON_IDS = "search-on-ids",
}

export interface IndexSearchRequestResource {
    types?: string[] | null
    criteriaTypes?: string[] | null
    queryText?: string | null
    savedRequest?: string | null
    advancedSearches?: RequestSearchInputResource[] | null
    filteredIds?: string[] | null
    excludedIds?: string[] | null
    searchOnArchived?: boolean | null
    pathAndValueToCheck?: PathAndValueToCheck | null
    searchOnVersioned?: boolean | null
    language?: string | null
    page?: number | null
    pageSize?: number | null
    sortObject?: SortObjectInputResource | null
    group?: string | null
    searchAlternative?: boolean | null
    sortWithId?: boolean | null
    facetsSearch?: FacetSearchInputResource[] | null
    institutionsCreation?: string[] | null
    useOCR?: boolean | null
    constraints?: RequestSearchInputResource[]| null
    backwardSearch?: BackwardSearchRequestResource | null
    typeSubject?: TypeSubject | null
    isPendingMedia?: boolean | null
    searchNotOnlySubject?: boolean | null
    includeDefaultSorts?: boolean | null
    linkedEntitiesIds?: string[] | null
    linkedEntitiesField?: string[] | null
    isFederateSearch?: boolean | null
    searchOnUnimarcTerm?: boolean | null
    excludeSiblings?: boolean | null
    imageSearch?: ImageSearchResource | null
    multilang?: boolean | null
    canSearchOnAllInstitution?: boolean | null
}

export enum RequestCriteriaResourceInputInterfaceTypes {
    CRITERIA = "criteria",
    NESTED_SEARCH = "nestedSearch",
    REQUEST_SEARCH = "requestSearch",
    ID_SEARCH = "idSearch",
}
interface RequestCriteriaResourceInputInterface {
    type: RequestCriteriaResourceInputInterfaceTypes
}

export interface RequestSearchInputResource extends RequestCriteriaResourceInputInterface {
    leftCriteria: RequestCriteriaResourceInputInterface 
    rightCriteria?: RequestCriteriaResourceInputInterface | null
    linkOperator?: LinkOperator | null
}

export interface CriteriaSearchInputResource extends RequestCriteriaResourceInputInterface {
    entityField?: string
    operator?: EsCriteriaOperator
    value?: AbstractRequestValueResource
    searchOnFirst?: boolean
    parentSearchOnFirst?: {[key: string]: boolean}
}

export interface NestedSearchInputResource extends RequestCriteriaResourceInputInterface {
    parentField: string
    criteriaList: RequestCriteriaResourceInputInterface[]
    searchOnFirst?: boolean
}

export enum AbstractRequestValueResourceTypes {
    DATE = "date",
    REFERENCE = "ref",
    TEXT = "text",
    PATH = "path",
    BOOLEAN = "bool",
    CROSSED_SEARCH = "crossed-search",
    SEARCH_ON_ID = "search-on-ids",
    // RequestCrossedSearchValueResource = "RequestCrossedSearchValueOutputResource" error in Tryphon sources
}
interface AbstractRequestValueResource {
    type: AbstractRequestValueResourceTypes
}

export interface RequestSkinDateValueResource extends AbstractRequestValueResource {
    min?: SkinInterval
    max?: SkinInterval
    text?: string
    searchOnNegativeDate?: boolean
    invalid?: boolean
    useDate?: SkinDateFormat
}

export interface RequestReferenceValueResource extends AbstractRequestValueResource {
    refId?: string
    completeSearch?: boolean
    searchOnUser?: boolean
    text?: string
}

export interface RequestTextValueResource extends AbstractRequestValueResource {
    text?: string | null
    isNumber?: boolean | null
}

export interface RequestPathValueResource extends AbstractRequestValueResource {
    path?: string
    refId?: string
    text?: string
    searchAlternative?: boolean
    searchOnChild?: boolean
}

export interface RequestBooleanValueResource extends AbstractRequestValueResource {
    bool: boolean
}

export interface RequestCrossedSearchValueResource extends AbstractRequestValueResource {
    indexSearchRequest?: IndexSearchRequestResource
    text?: string
}

export interface RequestSearchOnIdsValueResource extends AbstractRequestValueResource {
    ids?: string[]
}

export interface IdSearchInputResource {
    ids?: string[]
}

export enum LinkOperator {
    OR = "OR",
    AND = "AND",
    NOT = "NOT",
}

export interface PathAndValueToCheck {
    pathToValue?: string | null
    type?: string | null
    value?: any
}

export interface SortObjectInputResource {
    entityFields?: string[]
    customSortFields?: CustomSortFieldResource[]
    sortAsc?: boolean 
    sortHierarchy?: boolean | null
}

interface CustomSortFieldResource {
    type?: string
    path?: string
}

interface FacetSearchInputResource {
    facetField?: string
    facetDatas?: string[]
    isBackwardFacet?: boolean
    backwardTypes?: string[]
    backwardSearch?: BackwardSearchRequestResource
}

interface BackwardSearchRequestResource {
    backwardSearch?: IndexSearchRequestResource
    backwardField?: string
    text?: string
    excludeSearch?: boolean
}

export enum TypeSubject {
    Person,
    Collectivity,
    Family,
    Brand,
    GeographicalName,
    ChronologicalPeriod,
    CommonName,
    AuthorTitle,
    UniformTitle,
    Form,
    Genres
}

export interface ImageSearchResource {
    mediaId?: string
    imageSearchId?: string
}